export default __webpack_public_path__ + "static/media/search-icon-white.6e846a51.svg";